import { render, staticRenderFns } from "./ProductImageWithThumbnails.vue?vue&type=template&id=4eaa4bae&scoped=true&"
import script from "./ProductImageWithThumbnails.vue?vue&type=script&lang=ts&"
export * from "./ProductImageWithThumbnails.vue?vue&type=script&lang=ts&"
import style0 from "./ProductImageWithThumbnails.vue?vue&type=style&index=0&id=4eaa4bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa4bae",
  null
  
)

export default component.exports